/**
 * User-visible copy strings for the World Cup pick persistence flow.
 */

export const WORLD_CUP_PICK_PERSISTENCE_COPY = {
  PICK_LOCKED_TITLE: 'Pick locked',
  PICK_LOCKED_MESSAGE:
    'This match has already started. Your pick could not be saved. Refreshing matches.',
  PICK_SAVED_MESSAGE: 'Pick saved',
  PICK_SAVE_FAILED_MESSAGE: "Couldn't save your pick. Check your connection and try again.",
} as const;
